import { collection } from 'firebase/firestore';
import { db } from './config';

const demosRef = collection(db, 'demos');
const usersRef = collection(db, 'members');

export { demosRef, usersRef };
